import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const API_URL = "http://localhost:1337/api";
const STRAPI_BASE_URL = "http://localhost:1337";

export default function Article() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log("Fetching article...");

        fetch(`${API_URL}/articles?filters[slug][$eq]=${slug}&populate=*`)
            .then((res) => {
                console.log("Response:", res);
                return res.json();
            })
            .then((data) => {
                console.log("DATA:", data);
                setArticle(data.data[0]);
            })
            .catch((err) => {
                console.error("ERROR:", err);
                setError("Failed to fetch the article. Please make sure the Strapi backend is running.");
            });

    }, [slug]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    if (error) return <p style={{ padding: "40px", color: "red", backgroundColor: "#FFF7F4" }}>{error}</p>;
    if (!article) return <p style={{ padding: "40px", backgroundColor: "#FFF7F4" }}>Loading...</p>;

    return (
        <div style={{ backgroundColor: "#FFF7F4", minHeight: "100vh", padding: "40px" }}>
            <nav style={{ marginBottom: "20px", fontSize: "0.9em" }}>
                <Link to="/" style={{ textDecoration: "none", color: "#666" }}>Home</Link>
                <span style={{ margin: "0 8px", color: "#aaa" }}>/</span>
                <Link to="/recent-thoughts" style={{ textDecoration: "none", color: "#666" }}>Recent Thoughts</Link>
                <span style={{ margin: "0 8px", color: "#aaa" }}>/</span>
                <span style={{ color: "#333", fontWeight: "bold" }}>{article.title}</span>
            </nav>
            {article.cover && (
                <img src={`${STRAPI_BASE_URL}${article.cover.url}`} alt={article.title} className="img-fluid rounded mb-4" style={{ maxHeight: "400px", width: "100%", objectFit: "cover" }} />
            )}
            <h1 className="fw-bold fs-1">{article.title}</h1>

            <div className="d-flex align-items-center mb-5 mt-2">
                <small className="text-muted me-3">{formatDate(article.publishedAt)}</small>
                {article.tags && article.tags.length > 0 && (
                    <div>
                        {article.tags.map(tag => (
                            <Link key={tag} to={`/tags/${tag}`} className="badge bg-secondary text-decoration-none me-2">{tag}</Link>
                        ))}
                    </div>
                )}
            </div>

            <div>
                {article.blocks?.map((block, index) => {

                    if (block.__component === "shared.rich-text") {
                        return (
                            <div key={index}>
                                <ReactMarkdown>{block.body}</ReactMarkdown>
                            </div>
                        );
                    }

                    if (block.__component === "shared.quote") {
                        return (
                            <blockquote key={index}>
                                <h3>{block.title}</h3>
                                <p>{block.body}</p>
                            </blockquote>
                        );
                    }

                    return null;
                })}
            </div>
        </div>
    );
}
